/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { DescriptionRunResultDTO } from "./DescriptionRunResultDTO";
import {
  DescriptionRunResultDTOFromJSON,
  DescriptionRunResultDTOFromJSONTyped,
  DescriptionRunResultDTOToJSON
} from "./DescriptionRunResultDTO";

/**
 *
 * @export
 * @interface PaginatedDescriptionRunsDTO
 */
export interface PaginatedDescriptionRunsDTO {
  /**
   *
   * @type {Array<DescriptionRunResultDTO>}
   * @memberof PaginatedDescriptionRunsDTO
   */
  items: Array<DescriptionRunResultDTO>;
  /**
   * Total runs matching the filters (authoritative for pagination).
   * @type {number}
   * @memberof PaginatedDescriptionRunsDTO
   */
  total: number;
  /**
   *
   * @type {number}
   * @memberof PaginatedDescriptionRunsDTO
   */
  limit: number;
  /**
   *
   * @type {number}
   * @memberof PaginatedDescriptionRunsDTO
   */
  offset: number;
}

/**
 * Check if a given object implements the PaginatedDescriptionRunsDTO interface.
 */
export function instanceOfPaginatedDescriptionRunsDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "items" in value;
  isInstance = isInstance && "total" in value;
  isInstance = isInstance && "limit" in value;
  isInstance = isInstance && "offset" in value;

  return isInstance;
}

export function PaginatedDescriptionRunsDTOFromJSON(json: any): PaginatedDescriptionRunsDTO {
  return PaginatedDescriptionRunsDTOFromJSONTyped(json, false);
}

export function PaginatedDescriptionRunsDTOFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedDescriptionRunsDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    items: (json["items"] as Array<any>).map(DescriptionRunResultDTOFromJSON),
    total: json["total"],
    limit: json["limit"],
    offset: json["offset"]
  };
}

export function PaginatedDescriptionRunsDTOToJSON(value?: PaginatedDescriptionRunsDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    items: (value.items as Array<any>).map(DescriptionRunResultDTOToJSON),
    total: value.total,
    limit: value.limit,
    offset: value.offset
  };
}
